module.exports = __webpack_public_path__ + "img/code.c2018391.png";